/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum VitalSignAndRespiratoryMonitoringAliases {
  FRAGMENT_RESPIRATORY_MONITORING = 'fragment-respiratory-monitoring',
  FRAGMENT_VITAL_SIGN = 'fragment-vital-sign',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_VITAL_SIGN_AND_RESPIRATORY_MONITORING = 'layout-vital-sign-and-respiratory-monitoring',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_RESPIRATORY_MONITORING = 'tab-with-content-respiratory-monitoring',
  TAB_WITH_CONTENT_VITAL_SIGN = 'tab-with-content-vital-sign',
}
export { VitalSignAndRespiratoryMonitoringAliases };
